import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import Vue from 'vue';

Vue.component(FeatherIcon.name, FeatherIcon);

// Custom Components
import DeleteConfirmationModal from '@/components/common/DeleteConfirmationModal.vue';
import ImageViewer from '@/components/common/ImageViewer.vue';
import ResourceDropdown from '@/components/common/ResourceDropdown.vue';
import ResourceListHeader from '@/components/common/list/ResourceListHeader.vue';
import TableSkeleton from '@/components/common/skeletons/TableSkeleton.vue';
import VueSkeletonLoader from 'skeleton-loader-vue';

Vue.component('resource-dropdown', ResourceDropdown);
Vue.component('skeleton-loader', VueSkeletonLoader);
Vue.component('resource-list-header', ResourceListHeader);
Vue.component('image-viewer', ImageViewer);
Vue.component('delete-confirmation-modal', DeleteConfirmationModal);

// Resource Components
import VendorDropdown from '@/components/common/VendorDropdown.vue';
Vue.component('vendor-dropdown', VendorDropdown);

import VendorCodeDropdown from '@/components/common/VendorCodeDropdown.vue';
Vue.component('vendor-code-dropdown', VendorCodeDropdown);

import HSCodeDropdown from '@/components/common/HSCodeDropdown.vue';
Vue.component('hs-code-dropdown', HSCodeDropdown);

// Form Components
import DateRangePicker from '@/components/common/form/DateRangePicker.vue';
import FormFieldsGroup from '@/components/common/form/FormFieldsGroup.vue';
import ImageField from '@/components/common/form/ImageField.vue';
import MultiFileUpload from '@/components/common/form/MultiFileUpload.vue';
import MultiImageField from '@/components/common/form/MultiImageField.vue';
import ResourceFormLayout from '@/components/common/form/ResourceFormLayout.vue';
Vue.component('resource-form-layout', ResourceFormLayout);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('image-field', ImageField);
Vue.component('multi-image-field', MultiImageField);
Vue.component('multi-file-upload', MultiFileUpload);
Vue.component('form-fields-group', FormFieldsGroup);

// Datatable Components
import ActionCell from '@/components/common/list/ActionCell.vue';
import PrimaryContactCell from '@/components/common/list/PrimaryContactCell.vue';
import ResourceListFilter from '@/components/common/list/ResourceListFilter.vue';
import StatusCell from '@/components/common/list/StatusCell.vue';
import TimestampCell from '@/components/common/list/TimestampCell.vue';
Vue.component('timestamp-cell', TimestampCell);
Vue.component('status-cell', StatusCell);
Vue.component('action-cell', ActionCell);
Vue.component('primary-contact-cell', PrimaryContactCell);
Vue.component('table-skeleton', TableSkeleton);
Vue.component('resource-list-filter', ResourceListFilter);

// FBR Invoice Components
import FormCheckbox from '@/views/apps/fbr-invoice/components/form/FormCheckbox.vue';
import FormInput from '@/views/apps/fbr-invoice/components/form/FormInput.vue';
import FormTextArea from '@/views/apps/fbr-invoice/components/form/FormTextArea.vue';
Vue.component('form-checkbox', FormCheckbox);
Vue.component('form-input', FormInput);
Vue.component('form-text-area', FormTextArea);
